import React from 'react';

class InlineSelectField extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isEditing: false,
            value: props.value
        };
        this.edit = this.edit.bind(this);
        this.cancel = this.cancel.bind(this);
        this.change = this.change.bind(this);
        this.commit = this.commit.bind(this);
    }

    edit() {
        this.setState({isEditing: true})
    }

    cancel() {
        this.setState({isEditing: false, value: this.props.value});
    }

    change(event) {
        this.setState({value: event.target.value});
    }

    commit() {
        this.props.onCommit(this.state.value);
        this.setState({isEditing: false});
    }

    render() {
        if (this.state.isEditing) {
            return (
                <div style={{width: this.props.width}} onClick={this.toggleEdit}>
                    <div className="input-group">
                        <select name="select"
                                id="select"
                                className="form-control"
                                value={this.state.value}
                                onChange={this.change}>
                            {this.props.options.map(option => {
                                return <option key={option.id} value={option.id}>{option.label}</option>
                            })}
                        </select>
                        <div className="input-group-btn">
                            <button className="btn btn-success btn-sm" onClick={this.commit}><i className="fa fa-check"/>&nbsp;
                            </button>
                            <button className="btn btn-secondary btn-sm" onClick={this.cancel}><i
                                className="fa fa-times"/>&nbsp;</button>
                        </div>
                    </div>
                </div>
            )
        }
        return (
            <div style={{width: this.props.width}} onClick={this.edit}>
                <span>{this.props.options.find(option => option.id === this.state.value).label}</span>
            </div>
        );
    }
}

InlineSelectField.defaultProps = {width: '200px'};

export default InlineSelectField;



// WEBPACK FOOTER //
// ./src/admin/components/InlineSelectField.js